import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState } from "react";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: "2px 4px",
		display: "flex",
		alignItems: "center",
		width: 400,
	},
	input: {
		marginLeft: theme.spacing(1),
		flex: 1,
	},
	iconButton: {
		padding: 10,
	},
	divider: {
		height: 28,
		margin: 4,
	},
}));

export default function CustomizedInputBase(props) {
	const classes = useStyles();
	const [value, setValue] = useState();

	return (
		<Paper component="form" className={classes.root}>
			<IconButton className={classes.iconButton} aria-label="menu">
				<MenuIcon />
			</IconButton>
			<InputBase
				className={classes.input}
				placeholder={props.placeholder}
				inputProps={{ "aria-label": "search google maps" }}
				onChange={(e) => {
					props.handleSearch(e, value);
					setValue(e.target.value);
				}}
			/>

			<Divider className={classes.divider} orientation="vertical" />
			<IconButton
				type="submit"
				className={classes.iconButton}
				aria-label="search"
				onClick={(e) => props.handleSearch(e, value)}
			>
				<SearchIcon />
			</IconButton>
		</Paper>
	);
}
